import { render, staticRenderFns } from "./MessagePanel.vue?vue&type=template&id=2f7a306c&scoped=true&"
import script from "./MessagePanel.vue?vue&type=script&lang=ts&"
export * from "./MessagePanel.vue?vue&type=script&lang=ts&"
import style0 from "./MessagePanel.vue?vue&type=style&index=0&id=2f7a306c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a306c",
  null
  
)

export default component.exports